import React, {Component} from "react";
import Title from "../../components/Title";
import Breadcrumbs from "../../components/UI/Breadcrumbs";
import Layout from "../../containers/Layout";
import PickCity from "../../containers/PickCity";
import Couriers from "../../containers/Couriers";
import CourierNavbar from "../../containers/CourierNavbar";


class CouriersPage extends Component {
    render() {
        return (
            <Layout>
                <Title>Курьеры</Title>
                <Breadcrumbs links={[
                    {name: 'Главная', url: '/'},
                    {name: 'Курьеры', url: '/couriers'}
                ]}/>
                <div className={'mb-2'}>
                    <PickCity/>
                </div>
                <div className={'mb-2'}>
                    <CourierNavbar/>
                </div>
                <Couriers/>
            </Layout>
        );
    }
}

export default CouriersPage;
